export default __webpack_public_path__ + "static/media/ekincare_point.730c19a0.svg";